import Close from '@catalogo/ui-americanas-desktop-svg/close.svg';
import styled from 'styled-components';
import MagnifierSVG from '@catalogo/ui-americanas-desktop-svg/search.svg';

interface ISearchProps {
  isDesk: boolean;
}

const WrapperInput = styled.div<ISearchProps>`
  display: flex;
  position: relative;
  width: 100%;
  height: 32px;
  border: 1px solid #9e9e9e;
  border-radius: 100px;

  &:hover {
    border-color: #6f6f6f;
  }
`;

const Input = styled.input<ISearchProps>`
  caret-color: ${({ theme }) => theme.primaryColor};
  outline: 0;
  border: none;
  font-style: normal;
  font-weight: 400;
  font-size: ${({ isDesk }) => (isDesk ? '14px' : '12px')};
  line-height: 17px;
  height: 100%;
  width: ${({ isDesk }) => (isDesk ? '93%' : '80%')};
  background: #fff;
  color: #404040;
`;

const Magnifier = styled(MagnifierSVG)`
  padding: 7px 8px 8px 11px;
  position: relative;
  fill: #404040;
  cursor: pointer;
`;

const IconClose = styled(Close)`
  fill: ${({ theme }) => theme.primaryColor};
  padding: 7px 7px 7px 6px;
  margin-left: 8px;
  cursor: pointer;
`;

const SearchBox = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 0px 0px 16px 16px;
`;

const WrapperTitle = styled.div<ISearchProps>`
  background: #fafafa;
  border-width: 1px 1px 0px 1px;
  border-style: solid;
  border-color: #e9e9e9;
  border-radius: 16px 16px 0px 0px;
`;

const Title = styled.p<ISearchProps>`
  font-weight: 700;
  font-size: ${({ theme, isDesk }) => (isDesk ? theme.fontSize.sm : theme.fontSize.xs)};
  line-height: 120%;
  color: #666666;
  padding: 16px;
`;

export { Input, WrapperInput, Magnifier, IconClose, SearchBox, WrapperTitle, Title };
